module.exports = __webpack_public_path__ + "static/media/2-3.98e9e6a9.webp";